/**
 * VillaCardCarousel — tiny inline carousel used on the home-page combo villa
 * cards (7/8/9 BHK). Auto-rotates through 4-6 images drawn from the two
 * constituent villas, with dot indicators at the bottom. Pauses on hover.
 */

import React, { useEffect, useState } from 'react';

const VillaCardCarousel = ({ images = [], alt = '', interval = 3000, villaId }) => {
  const slides = images.slice(0, 6);
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused || slides.length <= 1) return;
    const t = setInterval(() => setIdx(i => (i + 1) % slides.length), interval);
    return () => clearInterval(t);
  }, [paused, slides.length, interval]);

  if (!slides.length) return null;

  return (
    <div
      className="relative w-full h-full overflow-hidden"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      data-testid={villaId ? `villa-card-carousel-${villaId}` : 'villa-card-carousel'}
    >
      {slides.map((src, i) => (
        <img
          key={src + i}
          src={src}
          alt={`${alt} — view ${i + 1}`}
          loading="lazy"
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${
            i === idx ? 'opacity-100' : 'opacity-0'
          }`}
        />
      ))}
      {slides.length > 1 && (
        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1.5 z-10">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); setIdx(i); }}
              aria-label={`Go to image ${i + 1}`}
              className={`h-1.5 rounded-full transition-all ${
                i === idx ? 'bg-white w-5' : 'bg-white/60 w-1.5'
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default VillaCardCarousel;
